import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import HistoryIcon from '@mui/icons-material/History';

// adminOnly items (quotes, team, the firm's activity log) are hidden from employees.
const menu = [
    { path: '/dashboard', label: 'nav.dashboard', icon: <SpaceDashboardOutlinedIcon /> },
    { path: '/clients', label: 'nav.clients', icon: <PeopleAltOutlinedIcon />, match: ['/clients'] },
    { path: '/quotes', label: 'nav.quotes', icon: <RequestQuoteOutlinedIcon />, match: ['/quotes'], adminOnly: true },
    { path: '/jobs', label: 'nav.jobs', icon: <WorkOutlineIcon />, match: ['/jobs'] },
    { path: '/planner', label: 'nav.planner', icon: <CalendarMonthOutlinedIcon /> },
    { path: '/map', label: 'nav.map', icon: <MapOutlinedIcon /> },
    { type: 'divider', label: 'nav.settings' },
    { path: '/settings/team', label: 'nav.team', icon: <GroupOutlinedIcon />, adminOnly: true },
    { path: '/activity', label: 'nav.activity', icon: <HistoryIcon />, adminOnly: true },
    { path: '/settings/categories', label: 'nav.categories', icon: <SellOutlinedIcon /> },
    { path: '/settings/company', label: 'nav.company', icon: <ApartmentOutlinedIcon /> },
    { path: '/settings/security', label: 'nav.security', icon: <ShieldOutlinedIcon /> },
];

export default menu;
